import { render } from "./AppEmptyContent.vue?vue&type=template&id=1f8ab933&scoped=true"
import script from "./AppEmptyContent.vue?vue&type=script&lang=js"
export * from "./AppEmptyContent.vue?vue&type=script&lang=js"

import "./AppEmptyContent.vue?vue&type=style&index=0&id=1f8ab933&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8ab933"]])

export default __exports__